export default "/images/454c43538a53e82cc0c7885955a9919b.jpg";